import { useQuery } from '@tanstack/react-query'
import { MarketplaceQueries } from '@/queries/marketplace/queries'
import { CustomQueryOptions } from '@/common/types_and_interfaces'
import {
  MarketplaceAffiliationPaginated,
  MarketplaceStorePaginated,
} from '@/queries/marketplace/schema'

export const useMarketplaceStores = (
  programId?: number,
  business_type?: string,
  search?: string,
  acceptingNewClients?: number,
  perPage: number = 10,
  page: number = 1,
  mySchools: boolean = false,
  options: CustomQueryOptions<MarketplaceStorePaginated> = {}
) => {
  return useQuery(
    MarketplaceQueries.getMarketplaceStores(
      programId!,
      business_type,
      search,
      acceptingNewClients,
      perPage,
      page,
      mySchools,
      options
    )
  )
}

export function useMarketplaceItemsByProvider(
  programId: number,
  providerId: number,
  business_type?: string,
  search?: string,
  perPage?: number,
  page?: number
) {
  return useQuery(
    MarketplaceQueries.getItemsByProvider(
      programId,
      providerId,
      business_type,
      search,
      perPage,
      page
    )
  )
}

export const useMarketplaceAffiliations = (
  programId?: number,
  search?: string,
  acceptingNewClients?: number,
  perPage: number = 10,
  page: number = 1,
  options: CustomQueryOptions<MarketplaceAffiliationPaginated> = {}
) => {
  return useQuery(
    MarketplaceQueries.getMarketplaceAffiliations(
      programId!,
      search,
      acceptingNewClients,
      perPage,
      page,
      options
    )
  )
}
